import { ColourPicker } from 'Shared/forms/ColourPicker';
import { LabelOnLeftWrap } from 'Shared/forms/Wrap';

export function Colour()
{
	return (
		<LabelOnLeftWrap label='Colour' narrow={true}>
			<ColourPicker field='colour' />
		</LabelOnLeftWrap>
	);
}

